








import { Component, Vue } from 'vue-property-decorator';
import { TimelineLite, Power4 } from 'gsap';

@Component({})
export default class Hamburger extends Vue {
  private timeline!: TimelineLite;
  private animationSpeed: number = 0.4;

  private get isOpen(): boolean {
    return this.$store.state.ui.sidebar;
  }

  private openSidebarMenu(): void {
    this.$store.commit('ui/setSidebar', !this.isOpen);
    this.animateButton(!this.isOpen);
  }

  private mounted(): void {
    this.timeline = new TimelineLite({ paused: true });

    this.timeline.fromTo(this.$refs.tl, this.animationSpeed, {
      top: '15px', width: '20px', ease: Power4.easeOut,
    }, {
      top: '22px', width: '20px', ease: Power4.easeOut,
    }, 'merge');

    this.timeline.fromTo(this.$refs.bl, this.animationSpeed, {
      bottom: '15px', width: '20px', ease: Power4.easeOut,
    }, {
      bottom: '22px', width: '20px', ease: Power4.easeOut,
    }, 'merge');

    this.timeline.fromTo(this.$refs.tl, this.animationSpeed, {
      rotationZ: 0,
      ease: Power4.easeOut,
    }, {
      rotationZ: -45,
      ease: Power4.easeOut,
    }, 'rotate');

    this.timeline.fromTo(this.$refs.bl, this.animationSpeed, {
      rotationZ: 0,
      ease: Power4.easeOut,
    }, {
      rotationZ: 45,
      ease: Power4.easeOut,
    }, 'rotate');

    this.timeline.fromTo(this.$refs.ml, this.animationSpeed, {
      rotationZ: 0,
      display: 'block',
      ease: Power4.easeOut,
    }, {
      rotationZ: -45,
      display: 'none',
      ease: Power4.easeOut,
    }, 'rotate');
  }

  private animateButton(isOpen: boolean): void {
    if (!isOpen) {
      this.timeline.play();
    } else {
      this.timeline.reverse();
    }
  }
}
